import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpHelperService } from '../services/http-helper.service';
import { environment } from '../../../environments/environment';
import { Login } from '../models/login';

@Injectable({ providedIn: 'root' })
export class LoginRepository {
  constructor(@Optional() private http?: HttpClient) {}

  /**
   * Logs a user into SCS
   *
   * @param username User name
   * @param password Password
   * @returns User login response stream
   */

  login(username: string, password: string): Observable<HttpResponse<any>> {
    if (!this.http) {
      throw new Error('HttpClient is required to perform HTTP requests in LoginRepository');
    }
    const url = environment.login.apiEndpoint;
    const helper = new HttpHelperService(this.http);
    const obs = helper.post<Login>(url, { password, username }, { withCredentials: true }) as unknown as Observable<HttpResponse<any>>;
    return this.doResponse(obs);
  }

  logout(token: string): Observable<HttpResponse<void>> {
    if (!this.http) {
      throw new Error('HttpClient is required to perform HTTP requests in LoginRepository');
    }
    const headers = new HttpHeaders().set('x-auth-token', token);
    const url = environment.login.logout;
    const helper = new HttpHelperService(this.http);
    const obs = helper.post<void>(url, null, { headers }) as unknown as Observable<HttpResponse<void>>;
    return this.doResponse(obs);
  }

  private doResponse<T>(obs: Observable<HttpResponse<T>>): Observable<HttpResponse<T>> {
    return obs.pipe(
      map((res) => res),
      catchError(this.handleError),
    );
  }

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error);
  }
}
